var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:_vm.$style.wrapper},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.$t('modal_messsages.card_daily_limit.title'))}}),_c('p',{domProps:{"innerHTML":_vm._s(
      _vm.$t('modal_messsages.card_daily_limit.content', {
        currencyUnit: _vm.currencyUnitList[_vm.asset],
        maxLimit: _vm.maxLimit
      })
    )}}),_c('BaseButton',{attrs:{"type":"primary"},on:{"click":_vm.handleClick}},[_vm._v(_vm._s(_vm._f("uppercase")(_vm.$t("Okay"))))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }